import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Container,
  Alert,
  Tabs,
  Tab,
  CircularProgress
} from '@mui/material';
import {
  Settings as SettingsIcon,
  Security as SecurityIcon,
  People as PeopleIcon
} from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../contexts/AuthContext';
import PermissionManagement from './PermissionManagement';
import PermissionTemplates from './PermissionTemplates';

const Admin: React.FC = () => {
  const { t } = useTranslation();
  const { user, token, hasPermission } = useAuth();
  const [activeTab, setActiveTab] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (user) {
      setLoading(false);
    }
  }, [user]);

  // Only allow access to users with admin.permissions
  if (!hasPermission('admin.permissions')) {
    return (
      <Container maxWidth="md">
        <Box sx={{ p: 3, textAlign: 'center' }}>
          <Alert severity="error">
            Prieiga draudžiama. Šis puslapis prieinamas tik administratoriams.
          </Alert>
        </Box>
      </Container>
    );
  }

  if (loading) {
    return (
      <Container maxWidth="md">
        <Box sx={{ p: 3, display: 'flex', justifyContent: 'center' }}>
          <CircularProgress />
        </Box>
      </Container>
    );
  }

  return (
    <Container maxWidth="xl">
      <Box sx={{ p: 3 }}>
        {/* Header */}
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
          <SettingsIcon sx={{ mr: 2, color: '#d32f2f', fontSize: 32 }} />
          <Typography variant="h4" component="h1" sx={{ color: '#d32f2f', fontWeight: 'bold' }}>
            🔧 Administratoriaus skydelis
          </Typography>
        </Box>


        {/* Tabs */}
        <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
          <Tabs value={activeTab} onChange={(e, newValue) => setActiveTab(newValue)}>
            {hasPermission('admin.permissions') && (
              <Tab icon={<PeopleIcon />} iconPosition="start" label={t('admin.tabs.userPermissions')} />
            )}
            {hasPermission('admin.permissions') && (
              <Tab icon={<SecurityIcon />} iconPosition="start" label={t('admin.tabs.permissionTemplates')} />
            )}
          </Tabs>
        </Box>

        {/* Tab Content */}
        {(() => {
          let tabIndex = 0;
          const hasPermissions = hasPermission('admin.permissions');
          
          if (hasPermissions && activeTab === tabIndex) {
            return <PermissionManagement />;
          }
          
          if (hasPermissions) tabIndex++;
          
          if (hasPermissions && activeTab === tabIndex) {
            return <PermissionTemplates />;
          }
          
          return null;
        })()}
      </Box>
    </Container>
  );
};

export default Admin;
